import { retrieveProductionToggles, isEnabled } from '@nuskin/ns-feature-flags';

const accertifyFraudService = function () {

    let transactionId;
    let accertifyReceivedTransactionID = false;
    let logsForDebugging = false;
    retrieveProductionToggles().then(() => {
        logsForDebugging = isEnabled('cx8_380_debugging');
    })

    const publicMethods = {
        initAccertify: (marketConfig) => {
            const ustr = Math.random().toString();
            const udat = new Date();
            const utid = ustr.substr(2, 5) + udat.getTime() + ustr.substr(7, 3);

            transactionId = `${marketConfig.accertifyTransactionIdPrefix}-${utid}`;
            accertifyReceivedTransactionID = false;
            let beaconScript = document.getElementById('bcn')

            if (beaconScript === null) {
                beaconScript = document.createElement('script');
                beaconScript.setAttribute('type', 'text/javascript');
                beaconScript.setAttribute('src', marketConfig.accertifyDataCollectorUrl);
                beaconScript.setAttribute('dvct', '500');
                beaconScript.setAttribute('sid', marketConfig.accertifySessionId);
                beaconScript.setAttribute('dvci', publicMethods.getTransactionID());
                beaconScript.setAttribute('id', 'bcn');
                beaconScript.setAttribute('dvc', 'a');
                beaconScript.setAttribute('async', 'true');
                beaconScript.onload = function () { publicMethods.registerCallbackWithAccertify(); };
                document.head.appendChild(beaconScript);
            } else {
                beaconScript.setAttribute('dvci', publicMethods.getTransactionID());
                // TODO: somebody know what this undefined function is supposed to do?
                // publicMethods.startDataCollection();
            }

        },

        registerCallbackWithAccertify: () => {
            if (logsForDebugging) {
                console.log("CX8:\n\tRegister the callback function")
            }
            if (Object.hasOwn(window, '_bcn') && Object.hasOwn(window._bcn, 'dvc')) {
                window._bcn.dvc.setSubmissionCallback(publicMethods.setAccertifyReceivedTransactionIDToTrue);
            }
        },

        setAccertifyReceivedTransactionIDToTrue: () => {
            accertifyReceivedTransactionID = true;

            if (logsForDebugging) {
                console.log("CX8:\n\tcallback function has been invoked")
            }
        },

        getAccertifyReceivedTransactionID: () => {
            return accertifyReceivedTransactionID;
        },

        retrieveAccertifyTransactionIdCustomPaymentField: () => {
            if (logsForDebugging) {
                console.log("CX8:\n\t adding custom payment field.");
            }

            return {
                Key: "ACCERTIFY_TRANSACTION_ID",
                Value: publicMethods.getTransactionID(),
                Type: "ACCERTIFY"
            };
        },

        accertifyInMarketConfig: (marketConfig) => {
            if (!marketConfig.accertifyEnabled) {
                return false;
            }
            if (
                marketConfig.accertifySessionId === undefined ||
                marketConfig.accertifyTransactionIdPrefix === undefined ||
                marketConfig.accertifyDataCollectorUrl === undefined) {
                return false;
            }
            return true;
        },

        getTransactionID: () => {
            return transactionId;
        }

    };

    return publicMethods;
}();

export default accertifyFraudService;
